import { colors, fontFamily } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { css } from '@emotion/react';

// Partial CSS Reset - adds foundation for light/dark themes and ADS styles
// https://bitbucket.org/atlassian/atlassian-frontend/src/master/packages/design-system/css-reset/src/base.tsx
export default css`
  background-color: ${token('elevation.surface', '#fff')};
  color: ${token('color.text', colors.N800)};
  font-family: ${fontFamily()};
  font-size: ${token('font.size.100', '14px')};
  font-style: normal;
  font-weight: 400;
  line-height: ${token('font.lineHeight.200', '1.42857142857143')};
  -ms-overflow-style: -ms-autohiding-scrollbar;
  text-decoration-skip-ink: auto;

  /* Links */
  a {
    color: ${token('color.link', colors.B400)};
    text-decoration: none;
  }
  /* stylelint-disable a11y/selector-pseudo-class-focus */
  a:hover {
    color: ${token('color.link', colors.B300)};
    text-decoration: underline;
  }
  a:active {
    color: ${token('color.link.pressed', colors.B500)};
  }
  a:focus-visible {
    outline: ${token('border.width.outline', '2px')} solid
      ${token('color.border.focused', colors.B200)};
    outline-offset: ${token('space.025', '2px')};
  }
  @supports not selector(*:focus-visible) {
    a:focus {
      outline: ${token('border.width.outline', '2px')} solid
        ${token('color.border.focused', colors.B100)};
      outline-offset: ${token('space.025', '2px')};
    }
  }
`;
